var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { useState, useCallback } from 'react';
export var useDragAndDrop = function () {
    var _a = useState([]), files = _a[0], setFiles = _a[1];
    var addFiles = useCallback(function (newFiles) {
        setFiles(function (prevFiles) { return __spreadArrays(prevFiles, newFiles); });
    }, []);
    var removeFile = useCallback(function (index) {
        setFiles(function (prevFiles) { return prevFiles.filter(function (_, i) { return i !== index; }); });
    }, []);
    var clearFiles = useCallback(function () {
        setFiles([]);
    }, []);
    return {
        files: files,
        addFiles: addFiles,
        removeFile: removeFile,
        clearFiles: clearFiles,
    };
};
